import MobileAppDownload from "./MobileAppDownload";

export default MobileAppDownload;
